export default "__VITE_ASSET__786ede7b__"